import Rollbar from "rollbar";

const env = process.env.NEXT_PUBLIC_ENV || process.env.NODE_ENV;
const codeVersion = process.env.NEXT_PUBLIC_RAILWAY_GIT_COMMIT_SHA;

const isLocal = env === "local" || !env;

const baseConfig = {
  enabled: !isLocal,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: env,
  replay: {
    enabled: true,
  },
  checkIgnore: (isUncaught: boolean, args: Rollbar.LogArgument[]) => {
    if (!isUncaught) {
      return true;
    }

    const error = args[0];
    if (error instanceof Error) {
      const errorMessage = error.message.toLowerCase();
      const errorName = error.name.toLowerCase();

      const ignoredErrors = [
        "network error",
        "failed to fetch",
        "networkrequestfailed",
        "aborted",
        "canceled",
        "timeout",
        "chunk load",
        "loading chunk",
        "loading css chunk",
        "resizeobserver loop",
        "non-error promise rejection",
        "script error",
      ];

      if (
        ignoredErrors.some(
          (ignored) =>
            errorMessage.includes(ignored) || errorName.includes(ignored),
        )
      ) {
        return true;
      }

      if (errorMessage.includes("404") || errorMessage.includes("not found")) {
        return true;
      }

      if (
        errorMessage.includes("401") ||
        errorMessage.includes("unauthorized")
      ) {
        return true;
      }

      if (errorMessage.includes("403") || errorMessage.includes("forbidden")) {
        return true;
      }
    }

    return false;
  },
  payload: {
    environment: env,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: codeVersion,
        guess_uncaught_frames: true,
      },
    },
  },
};

export const clientConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  ...baseConfig,
};

export const serverInstance = new Rollbar({
  accessToken: process.env.ROLLBAR_SERVER_TOKEN,
  ...baseConfig,
});
